export const chats = {
  chatListChatIfoAttachmentsText: 'Bijlage(n) verzonden',
  chatListChatNoMessagesText: 'Nog geen berichten',
  chatArchivedTitle: 'Gearchiveerde chats',
  chatsCreatePrivateCurtainTitle: 'Nieuwe chat',
  chatsCreatePrivateCurtaiSearchInputPlaceholder: 'Zoeken',
  chatsCreatePrivateCurtainCreateButtonTitle: 'Maken',
  chatCreateButtonTitle: 'Volgende',
  chatCreateNewGroupHeader: 'Nieuwe groep',
  chatGroupNameInputTitle: 'Groepsnaam',
  chatLogoTitle: 'Bewerken',
  chatCreateGroupButtonTitle: 'Groep maken',
  chatRequiredFieldsAlert: 'Groepsnaam moet worden opgegeven!',
  chatsCreateGroupChatLongTitleAlertText: 'Gebruik alstublieft een kortere titel!',
  chatsCreateGroupChatLBigImageAlertText: 'Kies alstublieft een kleiner afbeelding!',
  chatsNewChatInputPlaceholder: 'Schrijf een bericht',
  chatsNewChatAddedBigImageAlertText: 'Kies alstublieft een kleiner afbeelding!',
  chatOwnersArchiveOptionText: 'Archiveren',
  chatOwnersEditGroupOptionText: 'Bewerken',
  chatOwnersManageGroupOptionText: 'Leden beheren',
  chatOwnersChangeGroupOptionText: 'Groepseigenaar wijzigen',
  chatOwnersLeaveGroupOptionText: 'Verlaten',
  chatOwnersDeleteGroupOptionText: 'Chat verwijderen',
  chatpopupArchivedTitle: 'Chat archiveren',
  chatpopupArchivedDescription: 'Weet je het zeker?',
  chatArchiveGroupButtonTitleYes: 'Bevestigen',
  chatArchiveGroupButtonTitleCancel: 'Annuleren',
  chatEditGroupHeader: 'Chat bewerken',
  chatEditGroupEditLogoTitle: 'Bewerken',
  chatEditGroupButtonTitle: 'Opslaan',
  chatGroupEditAlertText: 'Succesvol opgeslagen!',
  chatManageGroupHeader: 'Beheren',
  chatManageGroupButtonTitle: 'Lid toevoegen',
  chatManageGroupSaveButtonTitle: 'Opslaan',
  chatAddUsersGroupHeader: 'Leden toevoegen',
  chatAddUsersGroupButtonTitle: 'Bevestigen',
  chatAddUsersGroupSearchInputPlaceholder: 'Zoeken',
  chatOwnershipTransferHeader: 'Eigendom overdragen',
  chatOwnershipTransferSearchInputPlaceholder: 'Zoeken',
  chatOwnershipTransferButtonTitle: 'Bevestigen',
  chatOwnerMarkText: '(jij)',
  chatOwnershipTransferAlertText: 'Eigendom overgedragen!',
  chatOwnerLeaveGroupTitle: 'Groep verlaten',
  chatOwnerLeaveGroupDescription: 'Je bent eigenaar van de chat, dus je moet eerst een nieuwe eigenaar kiezen voordat je vertrekt.',
  chatOwnerLeaveGroupButtonTitleYes: 'Kiezen',
  chatOwnerLeaveGroupButtonTitleNo: 'Annuleren',
  chatsGroupChatUsersCurtanArchOptionTitle: 'Archiveren',
  chatsGroupChatUsersCurtanMembersOptionTitle: 'Chatleden',
  chatsGroupChatUsersCurtanLeaveOptionTitle: 'Verlaten',
  chatsGroupChatMemberCurtainTitle: 'Chatleden',
  chatsGroupChatMemberCurtainSearchInputPlaceholder: 'Zoeken',
  chatsGroupChatMemberCurtainOwnerMarkText: '(eigenaar)',
  chatsGroupChatLeavePopupTitle: 'Verlaten',
  chatsGroupChatLeavePopupText: 'Weet je het zeker?',
  chatsGroupChatLeavePopupCancelButtonTitle: 'Annuleren',
  chatsGroupChatLeavePopupConfirmButtonTitle: 'Bevestigen',
  chatDeleteGroupTitle: 'Chat verwijderen',
  chatDeleteGroupDescription: 'De chat en zijn geschiedenis worden voor alle deelnemers verwijderd. Doorgaan?',
  chatDeleteGroupButtonTitleYes: 'Bevestigen',
  chatDeleteGroupButtonTitleNo: 'Annuleren',
  chatsPrivateChatCurtainArchOptionTitle: 'Archiveren',
  chatsEditMessage: 'Bericht bewerken',
  chatsCopyMessage: 'Bericht kopiëren',
  chatsDeleteMessage: 'Bericht verwijderen',
  chatsSelectMessage: 'Bericht selecteren',
  chatMarkTextEdit: '(bewerkt)',
  chatCopyMessageAlertText: 'Bericht gekopieerd!',
  chatDeleteMessageTitle: 'Bericht verwijderen',
  chatDeleteMessageDescription: 'Dit bericht verwijderen?',
  chatDeleteMessageButtonTitleYes: 'Bevestigen',
  chatDeleteMessageButtonTitleNo: 'Annuleren',
  chatSelectButtonDelete: 'Annuleren',
  chatSelectButtonNo: 'Verwijderen',
  chatDeleteMessagesTitle: 'Berichten verwijderen',
  chatDeleteMessagesDescription: 'Deze berichten verwijderen?',
  chatDeleteMessagesButtonTitleYes: 'Bevestigen',
  chatDeleteMessagesButtonTitleNo: 'Annuleren',
  chatArchiveButtonRestore: 'Herstellen',
  chatArchiveButtonNo: 'Verwijderen',
  chatNoUsersCurtainTitle: 'Oeps!',
  chatsNoUsersCurtainText: 'Het lijkt erop dat er geen andere gebruikers zijn dan jij. Nodig vrienden uit om te beginnen met chatten.',
  chatsNoUsersCurtainCancelButtonTitle: 'Annuleren',
  chatsNoUsersCurtainCopyButtonTitle: 'App-link kopiëren',
  chatsAppLinkCopiedAlertText: 'Link gekopieerd!',
  chatsTooFewUsers: 'Selecteer alsjeblieft minimaal één gebruiker om mee te chatten!',
  chatsError: 'Er is iets misgegaan!'
}
